import { RepositoryFactory } from '@/api/factory/repositoryFactory'
const OnlineCourseRepository = RepositoryFactory.get('onlineCourse')

const state = {
  courses: {},
  course: {},
  count: 0,
  statistic: [],
  coursesStatistics: {},
  countParticipant: 0,
  totalCount: 0,
  courseInTopic: [],
  liveCourses: [],
  countLiveCourse: 0
}
const actions = {
  async fetchCourses({ commit }, params = {}) {
    const res = await OnlineCourseRepository.fetch(params);
    commit("setCourses", res.data || []);
    return res.data;
  },
  async searchCourses({commit}, params={}) {
    const {keyword, ...data} = params
    let res;
    if(keyword) res = await OnlineCourseRepository.search({...params, indexType: 'index'});
    else res = await OnlineCourseRepository.fetch(data);
    commit("setCourses", res.data || []);
    return res.data;
  },
  async viewMoreCourse({commit}, params = {}) {
    const res = await OnlineCourseRepository.fetch(params);
    commit("setViewMoreCourse", res.data || []);
    return res.data;
  },
  async fetchCourseById({ commit }, id) {
    const res = await OnlineCourseRepository.fetchOne(id);
    commit("setCourse", res.data || {});
    return res.data;
  },
  async fetchCourseAndNoSetData(_, id) {
    const res = await OnlineCourseRepository.fetchOne(id);
    return res.data;
  },
  async createCourse({ commit }, data) {
    const res = await OnlineCourseRepository.create(data);
    commit("addCourse", res.data);
    return res.data;
  },
  async updateCourse({ commit }, { id, ...course }) {
    const res = await OnlineCourseRepository.update(id, course)
    commit('setCourse', res.data)
    return res.data
  },
  async removeCourse({ commit }, id) {
    await OnlineCourseRepository.remove(id)
    return commit('removeCourse', id)
  },
  async countAllCourse({ commit }, params = {}) {
    const res = await OnlineCourseRepository.count({ ...params })
    commit('setCount', res.data || 0)
    return res.data
  },
  async setCourse({ commit }, course) {
    return commit("replaceCourse", course);
  },
  async fetchStatistic({ commit }, params = {}) {
    const res = await OnlineCourseRepository.statistic({
      ...params,
    }); 
    commit("setCoursesStatistics", res.data || {})
    commit("setStatistic", res.data.courses || []);
    commit("setCountOfParticipant", res.data.totalCount || 0);
    commit("setTotalCountCourse", res.data.allCourses || 0)
    return res.data;
  },
  async countCourseIndependent(_, params = {}) {
    const res = await OnlineCourseRepository.count({ ...params })
    return res.data
  },
  async getCourseInTopic({commit}, params = {}) {
    const res = await OnlineCourseRepository.fetch(params)
    commit('setCourseInTopic', res.data)
    return res.data
  },
  async getLiveCourse({commit}, params = {}) {
    const res = await OnlineCourseRepository.getLiveCourse(params)
    commit('setLiveCourse', res.data)
    return res.data
  },
  async getCountLiveCourse({commit}, params = {}) {
    const res = await OnlineCourseRepository.countLiveCourse(params)
    commit('setCountLiveCourse', res.data)
    return res.data
  },
  async getCountLiveCourseIndependent(_, params = {}) {
    const res = await OnlineCourseRepository.countLiveCourse(params)
    return res.data
  },
  async getLiveCourseExcel(_, params = {}) {
    const res = await OnlineCourseRepository.getLiveCourse({...params, isExport: true})
    return res.data
  },
  async retryCountLiveCourse({commit, rootState}, params = {}) {
    const {liveCourses} = rootState.onlineCourse
    await OnlineCourseRepository.retryLiveCourse(params)
    await new Promise(resolve => setTimeout(resolve, 15000));
    const resLiveCourse = await OnlineCourseRepository.getLiveCourse({
      student: params?.studentId,
      course: params?.courseId
    })
    const liveCouse =  resLiveCourse.data.length > 0 ? resLiveCourse.data[0] : {}
    if(liveCouse.classinId){
      const newLiveCourses = liveCourses.map(item => item.id === liveCouse.id ? liveCouse : item)
      commit('setLiveCourse', newLiveCourses)
      return true
    }
    return false
  }
}

const mutations = {
  setCourses(state, courses) {
     (state.courses = courses.reduce(
      (acc, cur) => {
        const id = cur.id ?? cur.originId
        return ({ ...acc, [id]: cur })
      },
      {}
    ));
  },
  setViewMoreCourse(state, courses) {
    const data = courses.reduce(
      (acc, cur) => {
        const id = cur.id ?? cur.originId
        return ({ ...acc, [id]: cur })
      },
      {}
    )
    state.courses = {
      ...state.courses, ...data
    }
  },
  setCount(state, count) {
    return (state.count = count);
  },
  replaceCourse(state, course) {
    return (state.courses = {
      ...state.courses,
      [course.id]: course,
    });
  },
  setCourse(state, course) {
    state.course = course
  },
  addCourse(state, course) {
    state.count = state.count + 1;
    return (state.courses = {
      [course.id]: course,
      ...state.courses,
    });
  },
  removeCourse(state, id) {
    delete state.courses[id];
    state.courses = { ...state.courses };
  },
  setStatistic(state, statistic) {
    return state.statistic = statistic
  },
  setCountOfParticipant(state, count) {
    return state.countParticipant = count
  },
  setCoursesStatistics(state, statistics){
    return state.coursesStatistics = statistics
  },
  setTotalCountCourse(state, totalCount){
    return state.totalCount = totalCount
  },
  setCourseInTopic(state, val) {
    return state.courseInTopic = val
  },
  setLiveCourse(state, val) {
    return state.liveCourses = val
  },
  setCountLiveCourse(state, val) {
    return state.countLiveCourse = val
  },
}
const getters = {
  getCount: state => {
    return state.count
  },
  getCourses: state => {
    return Object.values(state.courses);
  },
  getCourse: state => {
    return state.course
  },
  getCountParticipant: (state) => {
    return state.countParticipant
  },
  getAllStatistic: (state) => {
    return state.statistic
  },  
  getCoursesStatistics: (state) => {
    return state.coursesStatistics
  }, 
  getStatistic: (state) => {
    if (state.statistic.length >= 4) {
      return state.statistic.slice(0, 4)
    } else return state.statistic
  },
  getTotalCountCourse: (state) => {
    return state.totalCount
  },
  getCourseInTopic: (state) => {
    return state.courseInTopic
  },
  getCountLiveCourse: (state) => {
    return state.countLiveCourse
  },
  getLiveCourse: (state) => {
    return state.liveCourses
  }
}
export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}